import React from 'react';
import { motion } from 'framer-motion';
export function UrgencyBar() {
  return <motion.div initial={{
    y: -100
  }} animate={{
    y: 0
  }} className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-red-800 to-red-900 text-white py-3 px-4 text-center shadow-lg" data-id="element-153">
      <p className="text-sm md:text-base font-semibold" data-id="element-154">
        ¡Oferta de Lanzamiento! Obtén el Protocolo hoy por solo $6,39 USD{' '}
        <span className="line-through opacity-75" data-id="element-155">
          (Precio regular $37 USD)
        </span>
      </p>
    </motion.div>;
}